// src/reducers/checkout/placeorderReducer.js
import {
    SUBSCRIBE_COUPON_SUCCESS, SUBSCRIBE_COUPON_FAILURE, CLEAR_COUPON_SUBSCRIBE 
  } from "../../actions/types";
  
  const initialState = {
    Plan: null,
    error: null,
  };
  
  export const subscribeCouponReducer = (state = initialState, action) => {
    switch (action.type) {
      case SUBSCRIBE_COUPON_SUCCESS:
        return {
          ...state,
          Plan: action.payload,
          error: null,
        };
      case SUBSCRIBE_COUPON_FAILURE:
        return {
          ...state,
          Plan: null,
          error: action.payload,
        };
      case CLEAR_COUPON_SUBSCRIBE:
        return {
          ...state,
          Plan: null,
          error: null,
        };
      default:
        return state;
    }
  };
  